<template>
    <div>
        <hotel-room-offers
            v-if="!needUpdateRooms && updateRoomsActive !== true && loadedHdi"
            v-model="selectedOfferKeys"
            :offer="offer"
            :compare-mode="compareMode"
            :search-request="searchRequest"
            :is-package="isPackage"
        >
            <template v-slot:price="{room}">
                <slot name="price" :room="room" />
            </template>
        </hotel-room-offers>
        <template v-else>
            <v-card-title v-if="!offer" class="text-h6 font-weight-light">
                {{ $t('loading_room_offers') }}...
            </v-card-title>
            <v-skeleton-loader transition="fade-transition" height="100" type="list-item-three-line" />
        </template>
    </div>
</template>

<script lang="ts">
    import HotelRoomOffers from '~/components/search/offers/HotelRoomOffers.vue'
    import {hotelInfoResponse} from '@/utils/hotels/hotels-blank-states'
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'

    @Component({
        components: {
            HotelRoomOffers,
        },
    })
    export class HotelRoomOffersWrapper extends Vue {
        @VModel({default: () => []}) selectedOfferKeys
        @Prop() offer
        @Prop({default: false, type: Boolean}) compareMode
        @Prop({required: true}) searchRequest
        @Prop({default: false, type: Boolean}) isPackage

        hotelInfo = hotelInfoResponse()
        loadedHdi = false

        //TODO Try to cache component in parent - keep-alive
        async mounted() {
            await this.$store.restored
            const {supplierCode, cityCode, hotelCode} = this.offer
            const hotelInfoRq = {supplierCode, cityCode, hotelCode}
            try {
                await hotelsRuntimeStore.loadHotelsInfoByOffer(this.offer)
            } catch (e) {
                this.hotelInfo = hotelInfoResponse()
            } finally {
                this.loadedHdi = true
            }
            if (this.needUpdateRooms && !this.updateRoomsActive) {
                if (this.$route.name === 'packages') {
                    await packagesRuntimeStore.updatePackageOffers({
                        ...hotelInfoRq,
                        ...{offerId: this.offer.rooms[0].groupedOffers[0].offerKey},
                    })
                } else {
                    await hotelsRuntimeStore.updateRoomOffers(hotelInfoRq)
                }
            }
        }

        get needUpdateRooms() {
            if (this.$route.name === 'packages') {
                return packagesStore.needUpdateRooms(this.offer)
            } else {
                return hotelsRuntimeStore.needUpdateRooms(this.offer)
            }
        }

        get updateRoomsActive() {
            if (this.$route.name === 'packages') {
                return packagesRuntimeStore.updateRoomsActive(this.offer)
            } else {
                return hotelsRuntimeStore.updateRoomsActive(this.offer)
            }
        }
    }

    export default HotelRoomOffersWrapper
</script>
